var App = App || {};

App.WidgetTestimonials = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {

            const carousel = selector.find(".splide");
            const slides = carousel.find(".splide__slide");

            if (slides.length > 1) {

                const options = {
                    type: 'slide',
                    speed: 500,
                    arrows: true,
                    pagination: false,
                    perMove: 1,
                    perPage: 1,
                    padding: '1rem',
                    gap: '2.5rem',
                    mediaQuery: 'max',
                    breakpoints: {
                        991: {
                            perMove: 1,
                            perPage: 1,
                            padding: '3rem',
                            gap: '1.5rem',
                        }
                    }
                };

                const splide = new Splide(carousel[0], options);
                splide.mount({});


                const newIndex = splide.index;
                const newActiveSlideElement = splide.Components.Elements.slides[newIndex];
                const slideData = newActiveSlideElement.getAttribute('data-gs-image');

                if (slideData == "False") {
                    $(carousel.find(".splide__arrows").addClass("no-image"));
                }

                splide.on('moved', function () {
                    noImage();
                });

                splide.on('resize', function () {
                    noImage();
                });

                function noImage() {
                    const newIndex = splide.index;
                    const newActiveSlideElement = splide.Components.Elements.slides[newIndex];

                    const slideData = newActiveSlideElement.getAttribute('data-gs-image'); // Example data attribute

                    if (slideData == "False") {
                        $(carousel.find(".splide__arrows").addClass("no-image"));
                    }
                    else if ($(carousel.find(".splide__arrows").hasClass("no-image"))) {
                        $(carousel.find(".splide__arrows").removeClass("no-image"));
                    }
                }
            }
        }
    }

    return {
        Init: Init
    };

})(jQuery);